import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-background" data-testid="terms-page">
      <div className="max-w-3xl mx-auto px-4 py-12">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground mb-8" data-testid="back-home-link">
          <ArrowLeft className="w-4 h-4" />
          Back to Home
        </Link>

        <h1 className="text-3xl font-bold font-['Outfit'] mb-2">Terms of Service</h1>
        <p className="text-sm text-muted-foreground mb-8">Last updated: February 11, 2026</p>

        <div className="prose prose-sm max-w-none space-y-6 text-foreground/80">
          <section>
            <h2 className="text-lg font-semibold text-foreground">1. Acceptance of Terms</h2>
            <p>By accessing or using ConnectMail ("the Service"), operated by ConnectMail Developments LLC, you agree to be bound by these Terms of Service. If you do not agree to these terms, do not use the Service.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-foreground">2. Description of Service</h2>
            <p>ConnectMail provides an email signature creation platform with an integrated advertising marketplace. Users can create professional email signatures, host ad slots within their signatures, and purchase ad placements in other users' signatures.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-foreground">3. Account Registration</h2>
            <ul className="list-disc pl-6 space-y-1">
              <li>You must provide accurate and complete information when creating an account.</li>
              <li>You are responsible for maintaining the security of your account credentials.</li>
              <li>You must be at least 18 years old to use the Service.</li>
              <li>One person or entity may not maintain more than one account.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-foreground">4. Subscription & Payments</h2>
            <ul className="list-disc pl-6 space-y-1">
              <li>The Service requires a paid subscription of $20 per month.</li>
              <li>Multi-month plans (3, 6, and 12 months) are available at the equivalent monthly rate.</li>
              <li>All payments are processed securely through Stripe.</li>
              <li>Subscriptions are non-refundable except as required by applicable law.</li>
              <li>You may cancel your subscription at any time with a 30-day notice period. Your account will remain active until the end of the notice period.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-foreground">5. Ad Marketplace</h2>
            <ul className="list-disc pl-6 space-y-1">
              <li>Ad slots are priced at a flat rate of $20 per month per slot.</li>
              <li>Ad placements require approval from the signature owner before going live.</li>
              <li>Revenue from ad placements is shared 50/50 between ConnectMail and the signature owner.</li>
              <li>Ad placements have a minimum 30-day commitment period.</li>
              <li>ConnectMail reserves the right to reject or remove ads that violate our content guidelines.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-foreground">6. Acceptable Use</h2>
            <p>You agree not to:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li>Use the Service for any illegal or unauthorized purpose.</li>
              <li>Upload content that is offensive, misleading, defamatory, or infringes on intellectual property rights.</li>
              <li>Attempt to gain unauthorized access to other accounts or our systems.</li>
              <li>Use the Service to distribute spam or unsolicited advertising beyond the designated ad marketplace.</li>
              <li>Interfere with or disrupt the integrity or performance of the Service.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-foreground">7. Intellectual Property</h2>
            <p>You retain ownership of content you upload to ConnectMail (logos, images, text). By uploading content, you grant ConnectMail a non-exclusive license to use, display, and distribute that content as necessary to provide the Service (e.g., rendering your email signature for recipients).</p>
            <p>The ConnectMail platform, including its design, code, and branding, is the property of ConnectMail Developments LLC.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-foreground">8. Limitation of Liability</h2>
            <p>ConnectMail Developments LLC shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising from your use of the Service. Our total liability shall not exceed the amount you paid to us in the 12 months preceding the claim.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-foreground">9. Disclaimer of Warranties</h2>
            <p>The Service is provided "as is" and "as available" without warranties of any kind, either express or implied. We do not guarantee that the Service will be uninterrupted, error-free, or free of viruses or other harmful components.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-foreground">10. Termination</h2>
            <p>We may suspend or terminate your account at any time for violation of these Terms. Upon termination, your right to use the Service ceases immediately. Sections regarding intellectual property, limitation of liability, and governing law survive termination.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-foreground">11. Governing Law</h2>
            <p>These Terms shall be governed by and construed in accordance with the laws of the State of Michigan, without regard to conflict of law principles.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-foreground">12. Changes to Terms</h2>
            <p>We reserve the right to modify these Terms at any time. We will notify users of material changes via email or through the Service. Continued use of the Service after changes constitutes acceptance of the updated Terms.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-foreground">13. Contact Us</h2>
            <p>If you have questions about these Terms, please contact us at:</p>
            <p className="mt-2">
              <strong>ConnectMail Developments LLC</strong><br />
              Troy, Michigan<br />
              <a href="mailto:connectmail@getfreshpass.com" className="text-accent underline">connectmail@getfreshpass.com</a>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
